import { interfaces } from 'inversify';
import getDecorators from 'inversify-inject-decorators';
import { container } from './container'

export const { lazyInject, lazyMultiInject } = getDecorators(container);

export const resolve = <T>(serviceIdentifier: interfaces.ServiceIdentifier<T>): T => {
  return container.get<T>(serviceIdentifier);
};
